import React, { useCallback } from 'react';

import Button from 'components/form/Button.component';
import DropdownFoldout from 'components/generic/DropdownFoldout.component';
import useTip from 'hooks/useTip.hook';
import { DEFAULT_LOCALE, LOCALE, useLocale } from 'providers/GILT.provider';

import CN from './ChangeLocaleDropdown.module.scss';

const LOCALES_MAP = Object.freeze({
  [LOCALE.uk]: 'en-GB 🇬🇧',
  [LOCALE.us]: 'en-US 🇺🇸',
});

const ChangeLocaleDropdown = () => {
  const { val: isDropdownRendered, tip: toggleDropdown } = useTip(false);

  const { locale, changeLocale } = useLocale();

  const updateLocale = useCallback(
    (newLocale) => {
      changeLocale(newLocale);
      toggleDropdown();
    },
    [changeLocale, toggleDropdown],
  );

  const dropdownButtonTitle = LOCALES_MAP[locale] || DEFAULT_LOCALE;

  return (
    <div className={CN.component} data-bem="ChangeLocaleDropdown">
      <Button variant="primary" onClick={toggleDropdown}>
        {dropdownButtonTitle}
      </Button>
      {isDropdownRendered && (
        <DropdownFoldout width="full" position="bottom">
          <DropdownFoldout.Body>
            <Button variant="icon" onClick={() => updateLocale(LOCALE.uk)}>
              {LOCALE.uk}
            </Button>
            <Button variant="icon" onClick={() => updateLocale(LOCALE.us)}>
              {LOCALE.us}
            </Button>
          </DropdownFoldout.Body>
        </DropdownFoldout>
      )}
    </div>
  );
};

export default ChangeLocaleDropdown;
